/** @module Enums */ /** typedoc */

/**
 * Should match the PayoutStatusEnum from the Distribution MS
 *
 * https://github.com/Mixgenius/LANDR.Distribution/blob/master/src/LANDR.Distribution/Services/Payouts/PayoutStatusEnum.cs
 */
export enum ReleasePayoutStatusEnum {
    Created = 'Created',
    Denied = 'Denied',
    Pending = 'Pending',
    Processing = 'Processing',
    Completed = 'Completed',
    Canceled = 'Canceled',
    Failed = 'Failed',
    UnClaimed = 'UnClaimed',
    Returned = 'Returned',
    OnHold = 'OnHold',
    Blocked = 'Blocked',
    PendingApproval = 'PendingApproval',
    Refunded = 'Refunded'
}
